import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import "./ChooseSportsOfInterest.scss";

const ChooseSportsOfInterest: React.FC = () => {
  const [selectedSports, setSelectedSports] = useState<number[] | never>([]);
  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
    register,
  } = useForm({
    defaultValues: {
      selectedAccount: -1,
    },
  });

  const onSubmit = (data: any) => {
    console.log(data);
    //       navigation.navigate("ChooseSportsOfInterest");
  };

  return (
    <>
      {/* <div className="sign-up-other-sports__caption">
        <p className="sign-up-other-sports__caption-title">
          Other sports of interest
        </p>
        <p className="sign-up-other-sports__caption-subtitle">
          Select which sports you're also interested in.
        </p>
        <p className="sign-up-other-sports__caption-subtitle--white">
          {selectedSports.length}/3 selected
        </p>
      </div>

      <form
        className="sign-up-other-sports__input"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="sign-up-other-sports__buttons">
          {sportsList.sports.map((value, index) => {
            return (
              <Button
                className={
                  selectedSports.includes(index)
                    ? "btn big-button active"
                    : "btn big-button "
                }
                action={() => {
                  if (
                    selectedSports.length < 3 &&
                    !selectedSports.includes(index)
                  ) {
                    setSelectedSports([...selectedSports, index]);
                  }

                  if (selectedSports.includes(index)) {
                    setSelectedSports(
                      selectedSports.filter((item) => item != index)
                    );
                  }
                  setValue("selectedAccount", index);
                }}
                key={index}
              >
                <div className="d-flex column center">
                  <img
                    src={require(`../../../assets/icons/${value.name}.png`)}
                    alt=""
                    className="sport-img"
                  />
                  {value.sport}
                </div>
              </Button>
            );
          })}
        </div>

        <Button
          className="btn btn-primary "
          action={() => navigate("/sign-up/bio")}
        >
          Next
        </Button>
      </form> */}
    </>
  );
};

export default ChooseSportsOfInterest;
